import { Form } from './modules/form/index';

Form();
